import {useMemo} from "react";

export function useModalSelectProps()
{
    return useMemo(() => {
        return {
            menuPortalTarget: document.body,
            menuPosition: 'fixed',
            styles: { menuPortal: base => ({ ...base, zIndex: 9999 }) },
        };
    });
}
